import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { authClient } from '@/lib/auth-client'
import { Logo } from '@/shared/ui/logo'

const HOME_PATH = '/'

type Quote = {
  readonly quote: string
  readonly author: string
}

const QUOTES: Record<string, readonly Quote[]> = {
  sv: [
    {
      quote: 'Ingenting är omöjligt för den som försöker.',
      author: 'Alexander den store',
    },
    {
      quote: 'Det enda sättet att göra ett bra arbete är att älska det du gör.',
      author: 'Steve Jobs',
    },
    {
      quote: 'Det bästa sättet att förutsäga framtiden är att skapa den.',
      author: 'Peter Drucker',
    },
    {
      quote:
        'Den enda gränsen för vår förverkligande av morgondagen är våra tvivel i dag.',
      author: 'Franklin D. Roosevelt',
    },
    {
      quote: 'Det enda vi har att frukta är fruktan själv.',
      author: 'Franklin D. Roosevelt',
    },
  ],
  en: [
    {
      quote: 'There is nothing impossible to they who will try.',
      author: 'Alexander the Great',
    },
    {
      quote: 'The only way to do great work is to love what you do.',
      author: 'Steve Jobs',
    },
    {
      quote: 'The best way to predict the future is to create it.',
      author: 'Peter Drucker',
    },
    {
      quote:
        'The only limit to our realization of tomorrow will be our doubts of today.',
      author: 'Franklin D. Roosevelt',
    },
    {
      quote: 'The only thing we have to fear is fear itself.',
      author: 'Franklin D. Roosevelt',
    },
  ],
}

export const Route = createFileRoute('/_app/login/_layout')({
  component: LoginLayout,
})

function LoginLayout() {
  const { i18n } = useTranslation()
  const { data: session, isPending } = authClient.useSession()
  if (isPending && !session) {
    return null
  }

  const quotes = QUOTES[i18n.language] ?? QUOTES.sv ?? []
  const randomIndex = Math.floor(Math.random() * quotes.length)
  const activeQuote = quotes[randomIndex] ?? quotes[0]

  return (
    <div className="flex h-screen w-full">
      <div className="absolute left-1/2 top-10 mx-auto flex -translate-x-1/2 transform lg:hidden">
        <Link
          to={HOME_PATH}
          className="z-10 flex h-10 flex-col items-center justify-center gap-2"
        >
          <Logo />
        </Link>
      </div>
      <div className="relative hidden h-full w-[50%] flex-col justify-between overflow-hidden bg-card p-10 lg:flex">
        <Link to={HOME_PATH} className="z-10 flex h-10 w-10 items-center gap-1">
          <Logo />
        </Link>

        {activeQuote && (
          <div className="z-10 flex flex-col items-start gap-2">
            <p className="text-base font-normal text-primary">
              {activeQuote.quote}
            </p>
            <p className="text-base font-normal text-primary/60">
              -{activeQuote.author}
            </p>
          </div>
        )}
        <div className="base-grid absolute left-0 top-0 z-0 h-full w-full opacity-40" />
      </div>
      <div className="flex h-full w-full flex-col border-l border-primary/5 bg-card lg:w-[50%]">
        <Outlet />
      </div>
    </div>
  )
}
